export default function Cancel(scene, level) {
  return active => {
    active && console.log("setting cancel");
    if (active) {
      level.cancelled = true;
    }
  };
}